import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Space, DatePicker, message } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import _ from 'lodash'

const { Column } = Table
const { RangePicker } = DatePicker

type fetchParams = {
    store_id: undefined | string,
    order_code: undefined,
    customer_name: string | undefined,
    customer_phone: string | undefined,
    inDate: null,
    handleDate: null
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        order_code: undefined,
        customer_name: undefined,
        customer_phone: undefined,
        inDate: null,
        handleDate: null
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    // 汇总数据
    const [summaryData, setSummaryData] = useState<any>([])
    const [summaryLoading, setSummaryLoading] = useState<boolean>(false)

    const [loading, setLoading] = useState<boolean>(false)

    // 权限数据获取
    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        if (fetchOtherParams.inDate) {
            fetch({ pagination, fetchOtherParams })
        }
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        if (fetchOtherParams.inDate) {
            const p = { ...pagination }
            p.current = 1

            fetch({ pagination: p, fetchOtherParams })

        } else {
            message.error('必须选择订单日期')
        }
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)
        setSummaryLoading(true)

        // 清空汇总数据
        setSummaryData("")

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'inDate', ['create_start_date', 'create_end_date'])

        axiosTable.get('/finance_center/business_report/chan_kang/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)

                // 设置汇总列表数据
                const { chan_kang_report_summary } = response
                if (chan_kang_report_summary && chan_kang_report_summary.length) {
                    setSummaryData(chan_kang_report_summary)
                }
            }

            setLoading(false)
            setSummaryLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    // 数据导出
    const exportExcel = () => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        if (params.inDate) {
            params.create_start_date = params.inDate[0].format('YYYY-MM-DD')
            params.create_end_date = params.inDate[1].format('YYYY-MM-DD')
            delete params.inDate
        }

        baseAxiosComplete('/finance_center/business_report/chan_kang/excel', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    return (<div className="common-page">
        {/* 财务中心 -> 经营报表 -> 产康经营报表 */}
        <BreadCrumb position={['财务中心', '产康经营报表']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores value={fetchOtherParams.store_id} onChange={(v: string) => {
                        handleChange(v, 'store_id')
                    }} />
                </div>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["下单开始日期", "下单结束日期"]} value={fetchOtherParams.inDate} onChange={(v: any) => { handleChange(v, 'inDate') }} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="订单编号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'order_code') }} value={fetchOtherParams.order_code} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'customer_name') }} value={fetchOtherParams.customer_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'customer_phone') }} value={fetchOtherParams.customer_phone} />
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') && <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed" >导出</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} pagination={pagination} onChange={handleTableChange}>
                <Column title="门店" dataIndex="store_name" key="store_name" />
                <Column title="下单时间" dataIndex="create_time" key="create_time" />
                <Column title="订单编号" dataIndex="order_code" key="order_code" />
                <Column title="客户姓名" dataIndex="customer_name" key="customer_name" />
                <Column title="手机号码" dataIndex="customer_phone" key="customer_phone" />
                <Column title="付款金额" dataIndex="pay_amount" key="pay_amount" />
                <Column title="退款金额" dataIndex="refund_amount" key="refund_amount" />
                <Column title="结转金额" dataIndex="settlement_amount" key="settlement_amount" />
            </Table>
        </div>

        {/* 汇总数据 */}
        <div className="common-main">
            <h3>汇总</h3>

            <Table loading={summaryLoading} dataSource={summaryData} scroll={{ x: 'max-content' }} bordered={true} pagination={false}>
                <Column title="门店" dataIndex="store_name" key="store_name" />
                <Column title="订单数" dataIndex="order_num" key="order_num" />
                <Column title="付款总金额" dataIndex="pay_amount" key="pay_amount" />
                <Column title="退款总金额" dataIndex="refund_amount" key="refund_amount" />
                <Column title="结转总金额" dataIndex="settlement_amount" key="settlement_amount" />
            </Table>
        </div>
    </div>)
}